<template>
	<div style="height: 100%;">
		<div class="main_box">
			<div class="sype_title">{{$t('label_176')}}</div>
			<div style="display: flex;">
				<div style="display: flex;align-items: center">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['3'].color}"></div>
					<div style="margin-right: 10px">{{$t($store.getters.getColor['3'].description)}}</div>
				</div>
				<div style="display: flex;align-items: center">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['2'].color}"></div>
					<div style="margin-right: 10px">{{$t($store.getters.getColor['2'].description)}}</div>
				</div>
				<div style="display: flex;align-items: center">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['1'].color}"></div>
					<div>{{$t($store.getters.getColor['1'].description)}}</div>
				</div>
				<div style="display: flex;align-items: center;margin-right: 10px">
					<div style="width: 20px;height: 20px;margin-right: 5px" :style="{background:$store.getters.getColor['0'].color}"></div>
					<div>{{$t($store.getters.getColor['0'].description)}}</div>
				</div>
				<div class="date_box">
					<el-date-picker v-model="date" align="right" type="date" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                          :placeholder="$t('选择日期')" @change="changeDate" :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}">
					</el-date-picker>
					<i class="el-icon-arrow-left left" @click="changeDay(-7)"></i>
					<i class="el-icon-arrow-right right" @click="changeDay(7)"></i>
				</div>
			</div>

		</div>
		<div class="tableMin" style="margin-top:5px" v-if="tableShow">
			<div style="background-color:#45494f;color:#ffffff;line-height: 40px;font-size: 14px;font-weight: bold;">
				<span style="width:120px;display: inline-block;text-align: center;border-right: #ffffff solid 1px;">{{$t('label_70')}}</span><span
				 style="width:calc(100% - 120px);display: inline-block;text-align: center;">{{$t('label_166')}}</span>
			</div>
			<div>
				<div v-for="(item,index) in tableData" style='display:flex;border-bottom:1px solid #D9D9D9;height:85px;'>
					<div style='line-height:85px;width:120px;text-align: center;'>{{item.date}}</div>
					<div class="deviceTime" style="width:calc(100% - 120px);height:85px;padding-top: 8px;" ref="singleTable">
						<TimeChart v-if="pageChange" :chartsId="'deviceTime'+item.date" :dataCode="eqDetailInfo.code" :dataName="eqDetailInfo.name"
						 :data="timeChartData[item.date]" :beginTime="tableData[index].beginTime" :endTime="tableData[index].endTime" ></TimeChart>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import * as echarts from 'echarts';
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import TimeChart from '@/components/list/chart/timeChart';
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import file from "@/assets/js/file/file.js";
	import tree from "@/components/list/tree/checkTree";
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";

	export default {
		name: 'weekly',
		components: {
			Page,
			TimeChart
		},
		props: {
			eqDetailInfo: {
				type: Object,
				default: {}
			},
			workTime: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				tableShow: false,
				date: '',
				beginTime: '',
				endTime: '',
				tableData: [{
					date: '',
					beginTime: '',
					endTime: ''
				}],
				timeChartData: {},
				tableWidth: 0,
				pageChange: true,
			}
		},
		methods: {
			selectTime() {
				this.tableShow = false;
				this.tableData = [];
				this.timeChartData = {};
				let sum = 0;
				for (let i = 0; i > -7; i--) {
					let d = this.calcDay(this.date, i);
					let b = this.calcTime(this.beginTime, i);
					let e = this.calcTime(this.endTime, i);
					this.tableData.push({
						date: d,
						beginTime: b,
						endTime: e
					});
					equipmentMonitoringService.selectTime([this.eqDetailInfo], b, e).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							sum++;
							let timeChartData_ = this.timeChartData;
							timeChartData_[d] = Object.values(data.data)[0];
							this.timeChartData = timeChartData_;
							if (sum == 7) {
								this.tableShow = true;
							}
						};
					}).catch((response) => {
						console.log(response)
					})
				}
			},
			changeDay(i) {
				let d = new Date(this.date).getTime() + 1000 * 60 * 60 * 24 * i;
				if (d > Date.now()) {
					d = Date.now();
				}
				let date = new Date(d);
				this.date = date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
				this.changeDate();
			},
			calcTime(time, i) {
				let d = new Date(time).getTime() + 1000 * 60 * 60 * 24 * i;
				let date = new Date(d);
				return date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate()) +
					" " + this.zero(date.getHours()) + ":" + this.zero(date.getMinutes()) + ":" + this.zero(date.getSeconds());
			},
			calcDay(date, i) {
				let d = new Date(date).getTime() + 1000 * 60 * 60 * 24 * i;
				date = new Date(d);
				return date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
			},
			zero(i) {
				return i > 9 ? i : '0' + i;
			},
			refresh() {
				this.selectTime() //运转状况图
			},
			changeDate() {
				//计算开始和结束时间
				if (this.workTime.beginTimeOverDay == 0) {
					this.beginTime = this.date + this.workTime.beginTime.substring(10);
				} else {
					this.beginTime = this.calcDay(this.date, 1) + this.workTime.beginTime.substring(10);
				}
				if (this.workTime.endTimeOverDay == 0) {
					this.endTime = this.date + this.workTime.endTime.substring(10);
				} else {
					this.endTime = this.calcDay(this.date, 1) + this.workTime.endTime.substring(10);
				}
				this.refresh();
			},
			resizeChart() {
				this.pageChange = false;
				this.$nextTick(function() {
					this.pageChange = true;
				})
			},
			test3() {
				this.resizeChart()
			}
		},
		mounted() {
			this.changeDate();
			window.addEventListener('resize', this.resizeChart, true)
		},
		created() {
			window.test3 = this.test3;
			this.date = utils.getDayFormatDate();
			this.beginTime = this.workTime.beginTime;
			this.endTime = this.workTime.endTime;
		}
	}
</script>
<style>
	.main_box {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>
<style scoped>
  .tableMin {

  }

</style>



// WEBPACK FOOTER //
// src/components/list/equipmentDetails/weekly.vue